import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IApiKeyCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class ApiKeyCredentialsStore implements ICredentialsStore {
    private _changes: IApiKeyCredentialsModel = {} as IApiKeyCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get internalName() { return this._changes.internal_name; };
    public get apiKey() { return this._changes.api_key; };

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };
    
    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default ApiKeyCredentialsStore;
